import React, { useState } from "react";
import "../Styling/CN.css";
import { Link } from "react-router-dom";
import logo from "../Assets/logo.jpeg";
import {
  ChevronDown,
  Menu,
  X
} from "lucide-react";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="CN-navbar">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          {/* Brand */}
          <Link
            to="/"
            className="CN-brand"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              textDecoration: "none",
            }}
          >
            <img
              src={logo}
              alt="Digital Dream Works Logo"
              style={{
                width: "40px",
                height: "40px",
                objectFit: "contain",
              }}
            />
            <span>Digital Dream Works</span>
          </Link>

          {/* Nav Links */}
          <ul className={`CN-nav-links ${menuOpen ? "active" : ""}`}>
            <li className="CN-nav-item">
              <a href="#!" className="CN-nav-link CN-nav-link-bordered">
                Services <ChevronDown size={14} className="CN-dropdown-icon" />
              </a>
              <div className="CN-dropdown-menu">
                <Link to="/AI_Automation" className="CN-dropdown-item">
                  AI Systems & Automation
                </Link>
                <Link to="/CustomSoftware" className="CN-dropdown-item">
                  Custom Software Engineering
                </Link>
                <Link to="/MarketingSystem" className="CN-dropdown-item">
                  Marketing & Growth Systems
                </Link>
                <Link to="/Web&Conversion" className="CN-dropdown-item">
                  Web & Conversion Architecture
                </Link>
              </div>
            </li>

            <li className="CN-nav-item">
              <Link to="/Labs" className="CN-nav-link">
                Labs
              </Link>
            </li>
            <li className="CN-nav-item">
              <Link to="/How_we_work" className="CN-nav-link">
                How We Work
              </Link>
            </li>
            <li className="CN-nav-item">
              <Link to="/PartnerShips" className="CN-nav-link">
                Partnerships
              </Link>
            </li>
            <li className="CN-nav-item">
              <Link to="/AboutUs" className="CN-nav-link">
                About
              </Link>
            </li>
          </ul>

          {/* CTA */}
          <a
            href="https://portfolio.DigitalDreamWorksAgency.com"
            target="_blank"
            rel="noopener noreferrer"
            className="CN-cta-button"
          >
            Portfolio
          </a>


          {/* Mobile Toggle */}
          <button
            className="CN-mobile-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </nav>
  );
}
